import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { SequencePickerInputComponent } from '@modules/sequence/sequence-picker-input/sequence-picker-input.component';
import { TuiError, TuiTitle } from '@taiga-ui/core';
import { TelemonitoringRequestForm } from '../telemonitoring-request/telemonitoring-request-form';

@Component({
  selector: 'pxc-telemonitoring-request-sequences',
  imports: [CommonModule, SequencePickerInputComponent, TuiError, TranslocoDirective, ReactiveFormsModule, TuiTitle],
  templateUrl: './telemonitoring-request-sequences.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TelemonitoringRequestSequencesComponent {
  @Input() form: FormGroup<TelemonitoringRequestForm>;

  get patientId(): number {
    return this.form.get('patientId').value;
  }

  get clientCode(): string {
    return this.form.get('clientCode').value;
  }

  get departmentIds(): number[] {
    return this.form.get('departmentIds').value ?? [];
  }
}
